import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import React from "react";
var __jsx = React.createElement;
import classNames from "classnames";
import { Switch } from "@headlessui/react";
var Toggle = function Toggle(_ref) {
  var _ref$value = _ref.value,
    value = _ref$value === void 0 ? false : _ref$value,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$thumbClassName = _ref.thumbClassName,
    thumbClassName = _ref$thumbClassName === void 0 ? "" : _ref$thumbClassName;
  return /*#__PURE__*/React.createElement(Switch, {
    checked: value,
    onChange: !disabled ? onChange : undefined,
    onClick: function onClick(event) {
      return event.stopPropagation();
    },
    className: classNames("relative inline-flex h-5 w-7 flex-shrink-0 cursor-pointer rounded-full border-2 border-gray-500 transition-colors duration-200 ease-in-out dark:bg-black", {
      "opacity-50 !cursor-not-allowed": disabled
    })
  }, /*#__PURE__*/React.createElement("span", {
    className: classNames("pointer-events-none relative inline-block h-4 w-4 transform rounded-full bg-gray-500 shadow ring-0 transition duration-200 ease-in-out translate-x-0", _defineProperty({
      "!translate-x-5 bg-teal-500": value
    }, thumbClassName, !!thumbClassName && value))
  }, /*#__PURE__*/React.createElement("span", {
    "aria-hidden": "true",
    className: classNames("absolute inset-0 flex h-full w-full items-center justify-center transition-opacity opacity-100 ease-in duration-200", {
      "!opacity-0 !ease-out !duration-100": value
    })
  }, /*#__PURE__*/React.createElement("svg", {
    width: "8",
    height: "2",
    viewBox: "0 0 8 2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 1H7",
    stroke: "#0C1723",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("span", {
    "aria-hidden": "true",
    className: classNames("absolute inset-0 flex h-full w-full items-center justify-center transition-opacity opacity-0 ease-out duration-100", {
      "!opacity-100 !ease-in !duration-200": value
    })
  })));
};
export default Toggle;